import {
  gamificationQueries,
  type GamificationMember,
} from "@circle-react/lib/queries/gamification";
import { useQuery } from "react-query";

export interface UseGamificationMemberProps {
  enabled?: boolean;
  member_ids?: (number | string)[];
}

export const useGamificationMember = ({
  member_ids,
  enabled = true,
}: UseGamificationMemberProps) =>
  useQuery<GamificationMember[]>(
    gamificationQueries.memberScores({ memberIds: member_ids, enabled }),
  );
